<template>
  <b-modal modal-class="text-modal" :title="dataTitle" :id="dataId" centered size="xl" hide-footer>
    <template #modal-header-close>
      <font-awesome-icon class="fa-fw" :icon="['fas', 'times']"/>
    </template>
    <div class="text-modal-inner">
      <slot />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'textModal',
  props: {
    dataId: String,
    dataTitle: String
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
::v-deep #jobs-modal {
  .modal-header {
    padding-bottom: 16px;
  }
  .modal-body {
    padding-top: 0;
    box-sizing: border-box;
    max-height: calc(100vh - 56px - 45px - 32px - 64px);
    overflow: scroll;
  }
}
</style>
